// Markdown Table Generator Tool — build aligned GFM tables from a grid.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const markdownTableTool: Tool = {
  id: "markdown-table",
  name: () => m.mt_tool_name(),
  description: () => m.mt_tool_description(),
  icon: "🧮",
  basePath: "/markdown-table-generator",
  status: "stable",
  tags: ["markdown", "table", "gfm", "developer"],
  pages: [
    {
      name: () => m.mt_nav_main(),
      path: "/markdown-table-generator",
      description: () => m.mt_nav_main_desc(),
      icon: "🧮",
    },
  ],
};
